import { render, staticRenderFns } from "./ImportStudentsDialogMobile.vue?vue&type=template&id=0d855864&scoped=true"
import script from "./ImportStudentsDialogMobile.vue?vue&type=script&lang=js"
export * from "./ImportStudentsDialogMobile.vue?vue&type=script&lang=js"
import style0 from "./ImportStudentsDialogMobile.vue?vue&type=style&index=0&id=0d855864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d855864",
  null
  
)

export default component.exports